"use strict";
// @ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueVisitorId = exports.setVisitorId = exports.logout = exports.tokenNeedsRefresh = exports.isTokenValid = exports.setToken = exports.getToken = exports.TOKEN_KEY = void 0;
var moment_1 = __importDefault(require("moment"));
var ms_1 = __importDefault(require("ms"));
var nanoid_1 = require("nanoid");
var storage_1 = __importDefault(require("../utils/storage"));
exports.TOKEN_KEY = 'bp/token';
var MIN_MS_LEFT_BEFORE_REFRESH = (0, ms_1.default)('5m');
var getToken = function (onlyToken) {
    if (onlyToken === void 0) { onlyToken = true; }
    var parsedToken = storage_1.default.get(exports.TOKEN_KEY);
    return onlyToken ? parsedToken && parsedToken.token : parsedToken;
};
exports.getToken = getToken;
var setToken = function (token) {
    var storedToken;
    if (window.USE_JWT_COOKIES) {
        storedToken = { token: token.csrf, expiresAt: Date.now() + token.exp, issuedAt: Date.now() };
    }
    else {
        var _a = token.jwt.split('.'), payload = _a[1];
        var tokenUser = JSON.parse(atob(payload));
        storedToken = { token: token.jwt, expiresAt: tokenUser.exp, issuedAt: tokenUser.iat };
    }
    storage_1.default.set(exports.TOKEN_KEY, storedToken);
};
exports.setToken = setToken;
var isTokenValid = function () {
    var storedToken = (0, exports.getToken)(false);
    if (storedToken) {
        var token = storedToken.token, expiresAt = storedToken.expiresAt;
        return !!token && (0, moment_1.default)().unix() < expiresAt;
    }
    return false;
};
exports.isTokenValid = isTokenValid;
var tokenNeedsRefresh = function () {
    var tokenData = (0, exports.getToken)(false);
    var duration = moment_1.default.duration(moment_1.default.unix(tokenData.expiresAt).diff((0, moment_1.default)()));
    return duration.asMilliseconds() < MIN_MS_LEFT_BEFORE_REFRESH;
};
exports.tokenNeedsRefresh = tokenNeedsRefresh;
var logout = function (getAxiosClient) { return __awaiter(void 0, void 0, void 0, function () {
    var url, resp, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = '';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, getAxiosClient().get('/admin/auth/logout')];
            case 2:
                resp = _b.sent();
                url = resp.data.url;
                return [3 /*break*/, 5];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 5];
            case 4:
                storage_1.default.del(exports.TOKEN_KEY);
                if (url) {
                    // If /logout gave us a URL, manually redirect to this URL
                    window.location.replace(url);
                }
                else {
                    // need to force reload otherwise the token wont clear properly
                    window.location.href = window.location.origin + window['ROOT_PATH'];
                }
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.logout = logout;
var setVisitorId = function (userId, userIdScope) {
    if (typeof userId === 'string' && userId !== 'undefined') {
        storage_1.default.set(userIdScope ? "bp/socket/".concat(userIdScope, "/user") : 'bp/socket/user', userId);
        window.__BP_VISITOR_ID = userId;
    }
};
exports.setVisitorId = setVisitorId;
var getUniqueVisitorId = function (userIdScope) {
    var key = userIdScope ? "bp/socket/".concat(userIdScope, "/user") : 'bp/socket/user';
    var userId = storage_1.default.get(key);
    if (typeof userId !== 'string' || userId === 'undefined') {
        userId = (0, nanoid_1.nanoid)(24);
        storage_1.default.set(key, userId);
    }
    window.__BP_VISITOR_ID = userId;
    return userId;
};
exports.getUniqueVisitorId = getUniqueVisitorId;
